import {ChangeDetectionStrategy, Component, DestroyRef, inject, ViewEncapsulation} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {RouterOutlet} from '@angular/router';
import {TranslocoService} from '@jsverse/transloco';
import {MessageService} from '@openng/optimus-ui/api';
import {Toast, ToastModule} from '@openng/optimus-ui/toast';
import {NetworkRetryToastComponent} from '@scalified-monorepo/ng-shared';
import {ErrorService} from '@scalified-monorepo/ng-shared/errors';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, Toast, NetworkRetryToastComponent],
  providers: [MessageService],
  template: `
    <router-outlet></router-outlet>
    <p-toast
      appendTo="body"
      [breakpoints]="{'920px': {width: 'calc(100% - 20px)', right: '10px', left: '10px'}}"
      position="bottom-right"></p-toast>
    <network-retry-toast></network-retry-toast>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private errorService = inject(ErrorService);
  private destroyRef = inject(DestroyRef);
  private messageService = inject(MessageService);
  private translocoService = inject(TranslocoService);

  title = 'frontend-sample';

  constructor() {
    this.errorService.errors$
      .pipe(
        filter(({message}) => !!message),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(errorModel => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: this.translocoService.translate(errorModel.message),
          sticky: false,
        });
      });
  }
}
